<template>
  <div @click.stop="Gocomment(isClick)" :class="commentStyle">
    <i class="icon"></i><span v-if="count !== 0" class="desc">{{ count }}</span>
  </div>
</template>

<script>
export default {
  name: 'comment',
  props: ['commentStyle', 'count', 'commentGotop'],
  data () {
    return {
      isClick: true
    }
  },
  mounted () {
    if (this.commentGotop === undefined) this.isClick = false
  },
  methods: {
    /* 滑动到评论模块 */
    Gocomment (flag) {
      if (flag) {
        let top = this.commentGotop
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50
          if (top >= 0) {
            clearInterval(timeTop)
          }
        }, 10)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.iconcomment1{
  display: inline-block;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
  cursor: pointer;
  margin: 0 0 6px 0;
  transition: all 0.3s;
  position: relative;
  .icon{
    display: block;
    margin: 6px auto;
    width: 32px;
    height: 32px;
    background: url('../../assets/common/icon/icon-group2.png') no-repeat;
    background-position: 0px -160px;
    vertical-align: middle;
  }
  .desc{
    display: block;
    position: absolute;
    height: 14px;
    line-height: 14px;
    border-radius: 6px;
    padding: 0 4px;
    background: #b2bac2;
    color: #fff;
    left: 30px;
    top: -2px;
    font-size: 12px;
  }
  &:hover{
    .icon{
      background-position: -32px -160px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/amount/comment.vue